import { createApp } from 'vue'
import './index.css'
import App from './App.vue'

createApp(App).mount('#app')
